import Emitter from "./Emitter";

export default class GameLoadProgress extends Emitter {
    constructor(gb) {
        super(gb);
    }

    POKERSTARS_handler(data) {
        if (data.payload && data.payload.progress && data.payload.progress === 1) {
            if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
                window.parent.postMessage(JSON.stringify({"msgId":"rg2xcPreloaderEnd"}), this.gb.api.settings.pokerstarsOrigin);
            } else {
                window.parent.postMessage(JSON.stringify({"msgId":"rg2xcPreloaderEnd"}), "*");
            }
        } else if (data.payload && data.payload.progress && data.payload.progress < 1) {
            const dataForXc = {
                "msgId":"rg2xcPreloaderProgress",
                "percentage": data.payload.progress,
                "localizedText":"loading assets..."
            }
            // this.emitParent(JSON.stringify(dataForXc))

            if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
                window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
            } else {
                window.parent.postMessage(JSON.stringify(dataForXc), "*");
            }
        }
    }

    // PLAYTECH_handler(data) {
    //     if (data && data.payload && data.payload.progress && data.payload.progress <= 1 && this.gb.ptResFeat && this.gb.ptResFeat.includes('loadingstatus')) {
    //         let dataForW = {_type: "ucip.loadingstatus.g2wLoadingProgressNotification", progress: parseInt(data.payload.progress*100)}
    //         this.emitParent(JSON.stringify(dataForW));
    //     }
    // }

    _default(msg) {
        const data = msg ? { wpgaction: "loadProgress", param: msg } : { wpgaction: "loadProgress" };
        const dataParent = msg ? { wpgaction: "loadProgress.parent", param: msg } : { wpgaction: "loadProgress.parent" };

        this.emitTop(data);
        this.emitParent(dataParent);
    }
}
